import {
    // container,
    // defaultFont,
    primaryColor,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
    roseColor,
    transition,
    boxShadow,
    drawerWidth
} from "../../../assets/jss/dibots-global-style";

const headerStyle = theme => ({
    appBar: {
        display: "flex",
        border: "0",
        borderRadius: "3px",
        // padding: "0.625rem 0",
        // marginBottom: "20px",
        color: "inherit",
        width: "100%",
        backgroundColor: "inherit",
        boxShadow:
            "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
        // transition: "all 150ms ease 0s",
        alignItems: "center",
        flexFlow: "row nowrap",
        justifyContent: "flex-start",
        position: "absolute",
        bottom: "0",
        top: "auto",
        zIndex: "400",
        // height: "15%"
        height: "10%"
    },
    isFullScreen: {
        display: "none"
    },
    topAppBar: {
        top: "0 !important",
        bottom: "auto !important",
        position: "fixed",
        zIndex: "400",
        boxShadow: "none",
        background: "none",
        // height: "auto"
        height: "60px"
    },
    absolute: {
        position: "absolute",
        zIndex: "1100"
    },
    fixed: {
        position: "fixed",
        zIndex: "1100"
    },
    container: {
        // ...container,
        minHeight: "50px",
        flex: "1",
        alignItems: "center",
        justifyContent: "space-between",
        display: "flex",
        flexWrap: "nowrap",
        padding: "0px !important"
    },
    flex: {
        flex: 1
    },
    title: {
        padding: "0px 0px 0px 15px",
        "&:hover,&:focus": {
            // color: "inherit",
            background: "transparent",
            cursor: "pointer"
        },
        "& img": {
            transform: "translateZ(0)",
        }
        // "@media (max-width: 550px)": {
        //     width: "calc(100vw - 20%)",
        //     "& img": {
        //         width: "calc(100vw - 20%)"
        //     }
        // },
    },
    newTitle: {
        padding: "0px 0px 0px 15px",
        "&:hover,&:focus": {
            // color: "inherit",
            background: "transparent",
            cursor: "pointer"
        },
        "& img": {
            transform: "translateZ(0)",
            // background: "white"
        }
    },
    appResponsive: {
        margin: "20px 10px"
    },
    primary: {
        backgroundColor: primaryColor,
        color: "#FFFFFF",
        boxShadow:
            "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(156, 39, 176, 0.46)"
    },
    info: {
        backgroundColor: infoColor,
        color: "#FFFFFF",
        boxShadow:
            "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 188, 212, 0.46)"
    },
    success: {
        backgroundColor: successColor,
        color: "#FFFFFF",
        boxShadow:
            "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(76, 175, 80, 0.46)"
    },
    warning: {
        backgroundColor: warningColor,
        color: "#FFFFFF",
        boxShadow:
            "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(255, 152, 0, 0.46)"
    },
    danger: {
        backgroundColor: dangerColor,
        color: "#FFFFFF",
        boxShadow:
            "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(244, 67, 54, 0.46)"
    },
    rose: {
        backgroundColor: roseColor,
        color: "#FFFFFF",
        boxShadow:
            "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(233, 30, 99, 0.46)"
    },
    transparent: {
        backgroundColor: "transparent !important",
        boxShadow: "none",
        paddingTop: "25px",
        color: "#FFFFFF"
    },
    dark: {
        color: "#FFFFFF",
        backgroundColor: "#121212 !important",
        boxShadow:
            "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(33, 33, 33, 0.46)"
    },
    white: {
        border: "0",
        // padding: "0.625rem 0",
        padding: "0px !important",
        // marginBottom: "20px",
        color: "#555",
        backgroundColor: "#fff !important",
        boxShadow:
            "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
        // height: "fit-content"
    },
    blue: {
        color: "#FFFFFF",
        backgroundColor: "#003663 !important",
        boxShadow:
            "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(33, 33, 33, 0.46)"
    },
    drawerPaper: {
        border: "none",
        bottom: "0",
        transitionProperty: "top, bottom, width",
        transitionDuration: ".2s, .2s, .35s",
        transitionTimingFunction: "linear, linear, ease",
        width: drawerWidth,
        ...boxShadow,
        position: "fixed",
        display: "block",
        top: "0",
        height: "100vh",
        right: "0",
        left: "auto",
        visibility: "visible",
        borderTop: "none",
        textAlign: "left",
        paddingRight: "0px",
        paddingLeft: "0",
        ...transition,
        overflow: "hidden auto",
    },
    smallLinks: {
        marginTop: "60px",
    },
    hideLinks: {
        "@media (min-width: 960px)": {
            display: "none"
        },
        "@media (max-width: 960px)": {
            display: "block"
        }
    },
    searchBar: {
        flex: "1",
        "@media (max-width: 1024px)": {
            display: "none",
        }
    },
    searchResultBar: {
        flex: "0",
        height: "100px"
    },
    newsPageBar: {
        display: "none"
    },
    hiddenMenu: {
        marginRight: "15px",
        "@media (max-width: 1500px)": {
            display: "block"
        },
        "@media (min-width: 1500px)": {
            display: "none"
        }
    },
    topDarkColor: {
        // background: "linear-gradient(to bottom right, rgba(255, 255, 255, 1) 1%, rgba(0, 0, 0, 1) 100%)  !important",
        background: "#121212 !important",
        color: "white !important",
    },
    topLightColor: {
        background: "white !important",
        color: "black !important",
        ...boxShadow,
    },
    topBlueColor: {
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        // background: "#003663",
        color: "black !important",
        ...boxShadow,
    },
    icons: {
        width: "20px",
        height: "20px",
        marginRight: "3px"
    },
    navLink: {
        // color: "black",
        position: "relative",
        padding: "0.9375rem",
        fontWeight: "400",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        lineHeight: "20px",
        textDecoration: "none",
        margin: "0px",
        display: "inline-flex",
        "&:hover,&:focus": {
            color: "inherit",
            background: "rgba(200, 200, 200, 0.2)"
        },
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 30px)",
            marginLeft: "15px",
            marginBottom: "8px",
            marginTop: "8px",
            textAlign: "left",
            "& > span:first-child": {
                justifyContent: "flex-start"
            }
        }
    },
    listItem: {
        float: "left",
        color: "inherit",
        position: "relative",
        display: "block",
        width: "auto",
        margin: "0",
        padding: "0",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            "&:after": {
                width: "calc(100% - 30px)",
                content: '""',
                display: "block",
                height: "1px",
                marginLeft: "15px",
                backgroundColor: "#e5e5e5"
            },
            "&:last-child:after": {
                width: "100%",
                background: "rgba(0, 0, 0, 0.5)"
            }
        }
    },
    wordsLogo: { 
        fontSize: "50px", 
        textAlign: "center", 
        lineHeight: 1,
        marginTop: "12px",
        marginBottom: "8px", 
        position: "relative"
    },
    dotLogo: {
        position: "absolute",
        color: "#7a0026"
    },
    darkDotLogo: {
        position: "absolute",
        color: "white"
    }
});

export default headerStyle;
